import { memo, useEffect, useRef } from "react";
import PayoutSettings from "ui/forms/Merchant/PayoutSettings";
import { TabLayout } from "ui/widgets/StatefulTabs";
import { useMerchantProfileContext } from "../MerchantProfileProvider";
import useMerchantDetailsTabContext from "../../useMerchantDetailsTabContext";
import type { MerchantProfileRepository } from "../repository";

const PayoutSettingsTab = () => {
    const repository = useMerchantDetailsTabContext<MerchantProfileRepository>();
    const repositoryRef = useRef(repository);
    repositoryRef.current = repository;

    const { selectPayoutSettings } = useMerchantProfileContext();

    useEffect(() => {
        repositoryRef.current
            .fetchMerchantSettings();
    }, []);

    return (
        <TabLayout
            title='Payout settings'
        >
            <PayoutSettings
                {...selectPayoutSettings()}
            />
        </TabLayout>
    );
};

export default memo(PayoutSettingsTab);
